import React from 'react'
import LeadError from '../LeadError'
import NumberFormat from 'react-number-format'
import { DollarSign } from 'react-feather'


export default function LeadBudget(props) {
  const { data, setData, errors, setErrors } = props

  return (
    <div>
      <div className="p-8">
        <div className="m-auto md:w-64">
          <div className="relative flex items-center">
            <DollarSign
              size={20}
              className="absolute left-0 text-gray-400"
            />
            <NumberFormat
              autoFocus
              data-test-id='budget'
              value={data.budget}
              displayType={'input'}
              thousandSeparator={true}
              placeholder="Enter dollar amount"
              className={['input-underline pl-6']}
              onValueChange={values => {
                setErrors(null)
                const budget = values.floatValue
                setData(prev => ({
                  ...prev,
                  budget,
                }))
              }}
            />
          </div>
          {errors?.budget && (
            <LeadError message={errors.budget} color="text-red-600"/>
          )}
        </div>
      </div>
    </div>
  )
}
